import { Col, Container, Row } from "react-bootstrap";
import HOME_QUERY from "../../queries/home";
import Query from "../Query";
import { Link } from "react-router-dom";

const LeistungenBlock = () => {
  return (
    <Query query={HOME_QUERY} id={null}>
      {({ data: { home } }) => {
        return (
          <section className="layout layout__color_primary">
            <Container fluid>
              <Row className="justify-content-between mb-5">
                <Col md={6} lg={6} xxl={7} className="mb-5 mb-xl-0">
                  <h2 data-aos="fade-up">
                    {home.data.attributes.Services.title}
                  </h2>
                </Col>
                <Col xxl={4}>
                  <h4 className="h3 tt-normal" data-aos="fade-up">
                    {home.data.attributes.Services.description}
                  </h4>
                </Col>
                <Col xxl={1}></Col>
              </Row>
              <div className="layout_chapters">
                {home.data.attributes.Services.Categories.map((item, index) => {
                  return (
                    <Link
                      to={`/fuehrerscheine/${item.name}`}
                      target="_top"
                      rel="noopener noreferrer"
                      key={item.id}
                      className="layout_chapters_item"
                      data-aos="fade-up"
                    >
                      <Row>
                        <Col
                          xs={
                            index ===
                            home.data.attributes.Services.Categories.length - 1
                              ? 12
                              : 3
                          }
                          md={6}
                          xl={5}
                          xxl={6}
                          className={
                            index ===
                            home.data.attributes.Services.Categories.length - 1
                              ? "order-1 order-md-0 text-end text-md-start text-xxl-end mt-4 mt-md-0"
                              : "text-xxl-end"
                          }
                        >
                          <h3 className="text-xxl-end layout_chapters_title layout_chapters_title_new">
                            {item.name}
                          </h3>
                        </Col>
                        <Col
                          xs={
                            index ===
                            home.data.attributes.Services.Categories.length - 1
                              ? 12
                              : 9
                          }
                          md={6}
                          lg={5}
                          xl={4}
                          xxl={5}
                          className="offset-xl-1 layout_chapters_text"
                        >
                          <p
                            className="layout_text mb-3 mb-xxl-0"
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          />
                          <button
                            className={
                              index ===
                              home.data.attributes.Services.Categories.length -
                                1
                                ? "d-none"
                                : "btn btn__border btn__border_primary d-xxl-none"
                            }
                          >
                            Weiterlesen{" "}
                            <img
                              alt="team"
                              className="ms-2"
                              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAH1SURBVHgB7ZbPK0RRFMe/d8xQFhYo5UdZWFI2LJQkFixI88YGJTFYoJQ1Iv4A2cyvUIQ8FrNhgZJS2PEHKEkplIQw3nVGGXdW7/4opXwXr/NO75zPPfeee98F/vVLYlJfWdF9etZ/2RwnSLBGxHsfYSCP1FccOSmboRqZfBmTk3KxRmAnI0DwW2EgrTgvnoKB5KY6qUCkFpztkpWZwoN3YjO4Cg3JT5cdPCTwmOBJDjoGf7gKGpKv+FtWLESV9gsZrvHGqqjZrhWyQL1B8hJD4Pwg9c5RCB820DyXpZBFAxweeEeWEyDr4sfJa5CdHVLIAr0tsTpwC4/jJ+tJ8HbDHxuWTaG+xqICET81nC3k+QBjLbB7t91CjQ4B6vQtes4Kngxa/2W0R8vcQs3ASVVcjVO9ccGTS3WvuIWZgzVlDj4rmv46Qn90TxPe6RZm1lxWzKKttCHkSZDVBLtvzy1Uv+L2cCVBl5A++FEZKKBbcWukAD52SlaJ4F3EZl+PbAr1ivtDPnixng5lR3h+HoSC1MF33nk6JOoEzyXe6RTbHnmFgtTAVmQk7c8E/kLVWogHb6AohYtAtIG2zQ5Z3m8qRXdQM61BQ3IVty2UwsGaAE0OeUYXKg/2fNgEyhegcZRfTcBAkmD2ILwd042ji26ZDv71F/QJLMmBJZmuZ3AAAAAASUVORK5CYII="
                            ></img>
                          </button>
                        </Col>
                      </Row>
                    </Link>
                  );
                })}
              </div>
            </Container>
          </section>
        );
      }}
    </Query>
  );
};

export default LeistungenBlock;
